import CONSTANTS, { CONTENT_LIMIT } from "./constants";
import { call, delay, put, takeLatest, takeLeading } from "redux-saga/effects";
import { getActionObject } from "@src/utils/index";
import parseError from "@src/utils/parseError";
import {
  getContentAttachmentsService,
  getContentMarkAsDoneService,
  getCourseContentService,
  getCourseContentTestStatsService,
  getFreeCourseContentService,
  getTrialCourseContentService,
  idfyPostPurchageIdentityVerifyService,
  idfyPrepurchaseOtpGenerateService,
  idfyPrepurchaseOtpResendService,
  idfyPrepurchaseOtpVerifyService,
  markContentAsDoneService,
  patchContentMarkAsDoneService,
  polingSubmitIdfyDocService,
} from "./services";
import { transformParentFolder } from "./transformers";
import { openPullToRefreshAction } from "../../../PullToRefresh/store";
import { store } from "@root/store";

export const getUserToken = () => {
  const userTokenReducer = store?.getState()?.persistedDataReducer?.userToken;
  const userTokenQueryParam =
    typeof window !== "undefined"
      ? new URLSearchParams(window?.location?.search).get("token")
      : "";
  const userTokenLocalStorage =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("userToken")
      : "";

  const userTokenRefreshed =
    typeof window !== "undefined" ? window.refreshedToken : "";

  const userToken =
    userTokenRefreshed ||
    userTokenReducer ||
    userTokenQueryParam ||
    userTokenLocalStorage;
  return userToken;
};

function* getCourseContentSaga(data) {
  // IF DATA IS GETTING REFETCHED BUT DON"T WANT A LOADER ON SCREEN
  if (!data?.payload?.skipLoader) {
    // CLEARING CURRENT STATE WHILE FETCHING NEW DETAILS
    const clearContentAction = yield call(
      getActionObject,
      CONSTANTS.CLEAR_COURSE_CONTENT
    );
    yield put({ ...clearContentAction });
    const loaderAction = yield call(
      getActionObject,
      CONSTANTS.GET_COURSE_CONTENT_LOADER
    );
    yield put({ ...loaderAction });
  }
  try {
    const apiCall = yield call(getCourseContentService, data?.payload);
    const apiRes = apiCall?.data?.data;
    // console.log("A______", apiRes);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_COURSE_CONTENT_SUCCESS,
      {
        courseContent: {
          apiRes: apiRes?.courseContent,
          offset: data?.payload?.offset || 0,
          hasMore: apiRes?.courseContent?.length >= data?.payload?.limit,
        },
        currentFolderDetails: apiRes?.metadata?.currentFolderDetails,
        parentFolderDetails: transformParentFolder(
          apiRes?.metadata?.parentFolderDetails
        ),
      }
    );
    yield put({ ...getAction });

    // IF DATA IS GETTING REFETCHED FROM PULL TO REFRESH ACTION YOU NEED TO CLOSE THE PULL TO REFRESH LOADER
    if (data?.payload?.isPullToRefreshAction) {
      const pullToRefreshAction = yield call(openPullToRefreshAction);
      yield put({ ...pullToRefreshAction });
    }
  } catch (err) {
    parseError(err);
  }
}

function* getCourseContentLoadMoreSaga(data) {
  const loaderAction = yield call(
    getActionObject,
    CONSTANTS.GET_COURSE_CONTENT_LOADER
  );
  yield put({ ...loaderAction });
  try {
    const apiCall = yield call(getCourseContentService, data?.payload);
    const apiRes = apiCall?.data?.data;
    // console.log("A______", apiRes);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_COURSE_CONTENT_LOADED_MORE,
      {
        courseContent: {
          apiRes: apiRes?.courseContent,
          offset: data?.payload?.offset,
          hasMore: apiRes?.courseContent?.length >= data?.payload?.limit,
        },
      }
    );
    yield put({ ...getAction });
  } catch (err) {
    parseError(err);
  }
}

function* getTrialCourseContentSaga(data) {
  // IF DATA IS GETTING REFETCHED BUT DON"T WANT A LOADER ON SCREEN
  if (!data?.payload?.skipLoader) {
    // CLEARING CURRENT STATE WHILE FETCHING NEW DETAILS
    const clearContentAction = yield call(
      getActionObject,
      CONSTANTS.CLEAR_TRIAL_COURSE_CONTENT
    );
    yield put({ ...clearContentAction });
    const loaderAction = yield call(
      getActionObject,
      CONSTANTS.GET_TRIAL_COURSE_CONTENT_LOADER
    );
    yield put({ ...loaderAction });
  }
  try {
    const apiCall = yield call(getTrialCourseContentService, data?.payload);
    const apiRes = apiCall?.data?.data;
    // console.log("A______", apiRes);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_TRIAL_COURSE_CONTENT_SUCCESS,
      {
        courseContent: {
          apiRes: apiRes?.courseContent,
          offset: data?.payload?.offset || 0,
          hasMore: apiRes?.courseContent?.length >= data?.payload?.limit,
        },
        currentFolderDetails: apiRes?.metadata?.currentFolderDetails,
        parentFolderDetails: transformParentFolder(
          apiRes?.metadata?.parentFolderDetails
        ),
      }
    );
    yield put({ ...getAction });

    // IF DATA IS GETTING REFETCHED FROM PULL TO REFRESH ACTION YOU NEED TO CLOSE THE PULL TO REFRESH LOADER
    if (data?.payload?.isPullToRefreshAction) {
      const pullToRefreshAction = yield call(openPullToRefreshAction);
      yield put({ ...pullToRefreshAction });
    }
  } catch (err) {
    parseError(err);
  }
}

function* getTrialCourseContentLoadMoreSaga(data) {
  const loaderAction = yield call(
    getActionObject,
    CONSTANTS.GET_TRIAL_COURSE_CONTENT_LOADER
  );
  yield put({ ...loaderAction });
  try {
    const apiCall = yield call(getTrialCourseContentService, data?.payload);
    const apiRes = apiCall?.data?.data;
    // console.log("A______", apiRes);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_TRIAL_COURSE_CONTENT_LOADED_MORE,
      {
        courseContent: {
          apiRes: apiRes?.courseContent,
          offset: data?.payload?.offset,
          hasMore: apiRes?.courseContent?.length >= data?.payload?.limit,
        },
      }
    );
    yield put({ ...getAction });
  } catch (err) {
    parseError(err);
  }
}

function* getFreeCourseContentSaga(data) {
  // CLEARING CURRENT STATE WHILE FETCHING NEW DETAILS
  const clearContentAction = yield call(
    getActionObject,
    CONSTANTS.CLEAR_FREE_COURSE_CONTENT
  );
  yield put({ ...clearContentAction });
  const loaderAction = yield call(
    getActionObject,
    CONSTANTS.GET_FREE_COURSE_CONTENT_LOADER
  );
  yield put({ ...loaderAction });
  try {
    const apiCall = yield call(getFreeCourseContentService, data?.payload);
    const apiRes = apiCall?.data?.data;
    // console.log("A______", apiRes);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_FREE_COURSE_CONTENT_SUCCESS,
      {
        courseContent: {
          apiRes: apiRes?.courseContent,
          offset: data?.payload?.offset || 0,
          hasMore: apiRes?.courseContent?.length >= data?.payload?.limit,
        },
      }
      // apiRes.courseContent
    );
    yield put({ ...getAction });

    // IF DATA IS GETTING REFETCHED FROM PULL TO REFRESH ACTION YOU NEED TO CLOSE THE PULL TO REFRESH LOADER
    if (data?.payload?.isPullToRefreshAction) {
      const pullToRefreshAction = yield call(openPullToRefreshAction);
      yield put({ ...pullToRefreshAction });
    }
  } catch (err) {
    parseError(err);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_FREE_COURSE_CONTENT_FAILURE
    );
    yield put({ ...getAction });
  }
}

function* getFreeCourseContentLoadMoreSaga(data) {
  const loaderAction = yield call(
    getActionObject,
    CONSTANTS.GET_FREE_COURSE_CONTENT_LOADER
  );
  yield put({ ...loaderAction });
  try {
    const apiCall = yield call(getFreeCourseContentService, data?.payload);
    const apiRes = apiCall?.data?.data;
    // console.log("A______", apiRes);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_FREE_COURSE_CONTENT_LOADED_MORE,
      {
        courseContent: {
          apiRes: apiRes?.courseContent,
          offset: data?.payload?.offset,
          hasMore: apiRes?.courseContent?.length >= data?.payload?.limit,
        },
      }
    );
    yield put({ ...getAction });
  } catch (err) {
    parseError(err);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_FREE_COURSE_CONTENT_FAILURE
    );
    yield put({ ...getAction });
  }
}

function* getCourseContentTestStatsSaga(data) {
  // CLEARING CURRENT STATE WHILE FETCHING NEW DETAILS
  const clearContentAction = yield call(
    getActionObject,
    CONSTANTS.CLEAR_COURSE_CONTENT_TEST_STATS
  );
  yield put({ ...clearContentAction });
  const loaderAction = yield call(
    getActionObject,
    CONSTANTS.GET_COURSE_CONTENT_TEST_STATS_LOADER
  );
  yield put({ ...loaderAction });
  try {
    const apiCall = yield call(getCourseContentTestStatsService, data?.payload);
    const apiRes = apiCall?.data?.data;
    // console.log("A______", apiRes);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_COURSE_CONTENT_TEST_STATS_SUCCESS,
      apiRes
    );
    yield put({ ...getAction });
    // IF DATA IS GETTING REFETCHED FROM PULL TO REFRESH ACTION YOU NEED TO CLOSE THE PULL TO REFRESH LOADER
    if (data?.payload?.isPullToRefreshAction) {
      const pullToRefreshAction = yield call(openPullToRefreshAction);
      yield put({ ...pullToRefreshAction });
    }
  } catch (err) {
    parseError(err);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_COURSE_CONTENT_TEST_STATS_FAILURE
    );
    yield put({ ...getAction });
  }
}

function* addPreviewVideoContentSaga(data) {
  // CLEARING CURRENT STATE WHILE FETCHING NEW DETAILS
  // const clearContentAction = yield call(
  //   getActionObject,
  //   CONSTANTS.CLEAR_PREVIEW_VIDEO_CONTENT
  // );
  // yield put({ ...clearContentAction });
  const loaderAction = yield call(
    getActionObject,
    CONSTANTS.ADD_PREVIEW_VIDEO_CONTENT_LOADER
  );
  yield put({ ...loaderAction });
  try {
    const getAction = yield call(
      getActionObject,
      CONSTANTS.ADD_PREVIEW_VIDEO_CONTENT_SUCCESS,
      data?.payload
    );
    yield put({ ...getAction });
  } catch (err) {
    parseError(err);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.ADD_PREVIEW_VIDEO_CONTENT_FAILURE
    );
    yield put({ ...getAction });
  }
}

function* idfyPrepurchaseOtpGenerateSaga({ payload }) {
  try {
    const callback = payload?.callback;
    let apiService = "";
    if (payload?.isResend) {
      apiService = idfyPrepurchaseOtpResendService;
    } else {
      apiService = idfyPrepurchaseOtpGenerateService;
    }
    const response = yield call(apiService, payload);
    if (
      response?.data?.status === "success" &&
      response?.data?.data?.sessionId
    ) {
      if(callback) {
        callback();
      }
      yield put({
        type: CONSTANTS.IDFY_PREPURCHAGE_OTP_GENERATE_SUCCESS,
        payload: {
          isOtpGenerated: true,
          sessionId: response?.data?.data?.sessionId || null,
        },
      });
    }
  } catch (err) {
    parseError(err);
  }
}

function* idfyPrepurchaseOtpVerifySaga(data) {
  try {
    const callbackSuccess = data?.payload?.callback;
    const response = yield call(
      idfyPrepurchaseOtpVerifyService,
      data?.payload?.payload
    );

    if (response?.data?.status === "success" && callbackSuccess) {
      if (callbackSuccess) {
        callbackSuccess();
      }
    }
  } catch (err) {
    parseError(err);
  }
}

function* idfyPostPurchageIdentityVerifySaga(data) {
  try {
    const callback = data?.payload?.callback;
    const response = yield call(
      idfyPostPurchageIdentityVerifyService,
      data?.payload?.payload
    );
    if (
      response?.data?.status === "success" &&
      response?.data?.data?.redirectUrl &&
      callback
    ) {
      callback({
        isCall: true,
        url:  response?.data?.data?.redirectUrl|| "",
      });
      toastr.success("Success", response?.data?.message);
    } 
  } catch (err) {
    // parseError(err);
    console.log(err);
  }
}

function* getContentAttachmentsSaga(data) {
  const loaderAction = yield call(
    getActionObject,
    CONSTANTS.GET_CONTENT_ATTACHMENTS_LOADER
  );
  yield put({ ...loaderAction });
  try {
    const apiCall = yield call(getContentAttachmentsService, data?.payload);
    const apiRes = apiCall?.data?.data;
    const attachments = Array.isArray(apiRes)
      ? apiRes
      : apiRes?.attachments || [];
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_CONTENT_ATTACHMENTS_SUCCESS,
      attachments
    );
    yield put({ ...getAction });
  } catch (err) {
    parseError(err);
    const getAction = yield call(
      getActionObject,
      CONSTANTS.GET_CONTENT_ATTACHMENTS_FAILURE
    );
    yield put({ ...getAction });
  }
}

function* polingSubmitIdfyDocSaga(payload) {
  const callback = payload?.payload?.callback;
  try {
    const response = yield call(polingSubmitIdfyDocService, {
      data: {
        orgId: payload?.payload?.payload?.orgId || null,
        courseId: payload?.payload?.payload?.courseId || null,
      },
      token: getUserToken(),
    });
    if (response?.data?.status === "success" && response?.data?.data) {
      if (callback) {
        callback(response?.data?.data);
      }
    }
  } catch (err) {
    parseError(err);
  }
}

function* getContentMarkAsDoneSaga(payload) {
  const courseId = payload?.payload?.courseId;
  if (!courseId ) return;

  try {
    const response = yield call(getContentMarkAsDoneService, payload?.payload);
    if (response?.data?.status === "success" && response?.data?.data) {
      yield put({
        type: CONSTANTS.GET_CONTENT_MARK_AS_DONE_SUCCESS,
        payload: {
          contentIds: response?.data?.data || {},
        },
      });
    }
  } catch (err) {
    parseError(err);
  }
}

function* markContentAsDoneSaga(payload) {
  try {
    const response = yield call(markContentAsDoneService, payload?.payload);
    if (response?.data?.status === "success" ) {
      yield put({
        type: CONSTANTS.GET_CONTENT_MARK_AS_DONE,
        payload: {
          courseId: payload?.payload?.courseId,
        },
      });
    }
      
  } catch (err) {
    parseError(err);
  }
}

function* patchContentMarkAsDoneSaga(payload) {
  try {
    const response = yield call(patchContentMarkAsDoneService, payload?.payload);
    if (response?.status === 200 ) {
      yield put({
        type: CONSTANTS.GET_CONTENT_MARK_AS_DONE,
        payload: {
          courseId: payload?.payload?.courseId,
        },
      });
    }
  } catch (err) {
    parseError(err);
  }
}

export default function* actionWatcher() {
  yield takeLatest(CONSTANTS.GET_FREE_COURSE_CONTENT, getFreeCourseContentSaga);
  yield takeLatest(
    CONSTANTS.GET_FREE_COURSE_CONTENT_LOAD_MORE,
    getFreeCourseContentLoadMoreSaga
  );
  yield takeLatest(CONSTANTS.GET_COURSE_CONTENT, getCourseContentSaga);
  yield takeLatest(
    CONSTANTS.GET_COURSE_CONTENT_LOAD_MORE,
    getCourseContentLoadMoreSaga
  );
  yield takeLatest(CONSTANTS.GET_TRIAL_COURSE_CONTENT, getTrialCourseContentSaga);
  yield takeLatest(
    CONSTANTS.GET_TRIAL_COURSE_CONTENT_LOAD_MORE,
    getTrialCourseContentLoadMoreSaga
  );
  yield takeLatest(
    CONSTANTS.GET_COURSE_CONTENT_TEST_STATS,
    getCourseContentTestStatsSaga
  );
  yield takeLatest(
    CONSTANTS.ADD_PREVIEW_VIDEO_CONTENT,
    addPreviewVideoContentSaga
  );
   yield takeLatest(CONSTANTS.IDFY_PREPURCHAGE_OTP_GENERATE, idfyPrepurchaseOtpGenerateSaga);
   yield takeLatest(CONSTANTS.IDFY_PREPURCHAGE_OTP_VERIFY, idfyPrepurchaseOtpVerifySaga);
   yield takeLatest(CONSTANTS.IDFY_POSTPURCHAGE_IDENTITY_VERIFY, idfyPostPurchageIdentityVerifySaga);
   yield takeLatest(CONSTANTS.polingSubmitIdfyDoc, polingSubmitIdfyDocSaga);
   yield takeLatest(CONSTANTS.GET_CONTENT_ATTACHMENTS, getContentAttachmentsSaga);
   yield takeLeading(CONSTANTS.GET_CONTENT_MARK_AS_DONE, getContentMarkAsDoneSaga);
   yield takeLatest(CONSTANTS.MARK_CONTENT_AS_DONE, markContentAsDoneSaga);
   yield takeLatest(CONSTANTS.PATCH_CONTENT_MARK_AS_DONE, patchContentMarkAsDoneSaga);
}
